<template>
  <div >
    <v-navigation-drawer v-model="drawer" style="color: #0d4077!important" app temporary>
      <v-list dense>
       <!-- <v-list-item dark @click="$router.push('/')">
          <v-list-item-action>
            <v-icon>mdi-text-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Početna</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-list-item dark @click="viewRoute('/')">
          <v-list-item-action>
            <v-icon>mdi-text-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Почетна</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dark @click="viewRoute('/kompanije')">
          <v-list-item-action>
            <v-icon>apartment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>За компаније</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dark @click="viewRoute('/volontiraj')">
          <v-list-item-action>
            <v-icon>people</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>За волонтере</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!--        <v-list-item dark @click="$router.push('/o-nama')">
          <v-list-item-action>
            <v-icon>mdi-text-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>O nama</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dark v-if="!isLoggedIn" @click="$router.push('/prijava')">
          <v-list-item-action>
            <v-icon>mdi-application-import</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Prijava</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dark v-if="isLoggedIn" @click="$router.push('/registracija')">
          <v-list-item-action>
            <v-icon>mdi-card-account-details-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Registracija</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dark v-if="isLoggedIn" @click="logout">
        <v-list-item-action>
          <v-icon>mdi-application-export</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Odjava</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app light>
      <div class="d-flex align-center">

        <v-img max-width="25px" class="cover-img mr-2" src="../../assets/bgdlogo.png"></v-img>
        <h2>
          <router-link text to="/">
            <span class="mr-2">ОСТАНИ КОД КУЋЕ</span>
          </router-link>
        </h2>
      </div>

      <v-spacer></v-spacer>
<!--      <v-btn class="mr-2 hidden-sm-and-down" text to="/">
        <span>Pocetna</span>
      </v-btn>-->
      <v-btn class="mr-2 hidden-sm-and-down" text to="/">
        <span>Почетна</span>
      </v-btn>
      <v-btn class="mr-2 hidden-sm-and-down" text to="/kompanije">
        <span>За компаније</span>
      </v-btn>
      <v-btn class="mr-2 hidden-sm-and-down" text to="/volontiraj">
        <span>За волонтере</span>
      </v-btn>

<!--
      <v-btn v-if="isLoggedIn" class="hidden-sm-and-down" text to="/registracija">
        <span>Registracija</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" text to="/o-nama">
      <span>O nama</span>
    </v-btn>
      <v-btn v-if="!isLoggedIn" class="mr-2 hidden-sm-and-down" text to="/prijava">
        <span>Prijava</span>
      </v-btn>
      <v-btn v-if="isLoggedIn" class="mr-2 hidden-sm-and-down" text @click="logout">
        <span>Odjava</span>
      </v-btn>-->
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer" />
    </v-app-bar>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
  name: "Navbar",
  data: () => ({
    drawer: null
  }),
    computed: {
      ...mapGetters({
        userRole: 'userRole',
        isLoggedIn: 'isLoggedIn',
      })
    },
    methods: {
      logout: function() {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/");
        });
    },
      viewRoute(route){
        if (this.$route.path === route) {
          this.drawer = false;
        }else{
          this.$router.push(route)
        }
      }
  }
  };
</script>
<style >
  nav.v-navigation-drawer{
    background: #0d4077!important;
  }

  nav.v-navigation-drawer.v-navigation-drawer--fixed.v-navigation-drawer--is-mobile.v-navigation-drawer--open.v-navigation-drawer--temporary.theme--light{
    background: #0d4077!important;
    color: white;
  }
</style>
